import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import App from '../vue_widgets/sms_bot_preview.vue'

export default class extends Controller {

  static values = {
    chatbotId: String,
    inboxId: String,
    chatbotName: String,
    inboxName: String,
    clientId: String
  }

  connect(context) {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return
    console.log('sms preview widget controller connected.')

    const props = {
      chatbotId: this.chatbotIdValue,
      inboxId: this.inboxIdValue,
      chatbotName: this.chatbotNameValue,
      inboxName: this.inboxNameValue,
      clientId: this.clientIdValue

    }

    this.vue = createApp(App, props)
    this.vue.mount(this.element)
  }

  disconnect() {
    this.vue?.unmount()
  }
}
